import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseManageComments() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const commentsList = (bool, callback) => {
    MyAxios.get(`Admin_ManageComments`, {
      headers: {
        IsPage: bool ? true : false,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        response.data.resault.map((vP) => (vP.id = vP.userID));
        callback(response.data.resault);
      }
    });
  };

  const operatorsList = (callback) => {
    MyAxios.get(`Admin_ManageComments/Operators`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const DefaultOperator = (UserID, callback) => {
    const data = new FormData();
    data.append("UserID", UserID);
    MyAxios.post(`Admin_ManageComments/DefaultOperator`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کاربر پیش فرض ثبت شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const ChangeOperator = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ManageComments/ChangeOperator`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("انتقال کامنت ها باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  return {
    commentsList,
    operatorsList,
    DefaultOperator,
    ChangeOperator,
    validate,
  };
}
